import { EcardLandingHeader } from './EcardLandingHeader';
export default EcardLandingHeader;
